import Vue from 'vue'
import App from './App.vue'
import router from './services/router'
import vuetify from './plugins/vuetify'
import store from './services/index.js'
import * as firebase from 'firebase'
import VueCrontab from 'vue-crontab'
import VueYouTubeEmbed from 'vue-youtube-embed'
import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
// don't forget to import CSS styles
import 'tiptap-vuetify/dist/main.css'
// Vuetify's CSS styles 
import 'vuetify/dist/vuetify.min.css'

Vue.use(VueYouTubeEmbed)
Vue.use(VueCrontab)
Vue.config.productionTip = false
Vue.use(vuetify)
import VueQRCodeComponent from 'vue-qrcode-component'
Vue.component('qr-code', VueQRCodeComponent)
Vue.use(TiptapVuetifyPlugin, {
	// the next line is important! You need to provide the Vuetify Object to this place.
	vuetify, // same as "vuetify: vuetify"
	// optional, default to 'md' (default vuetify icons before v2.0.0)
	iconsGroup: 'mdi'
  })

const configOptions = {
    apiKey: "AIzaSyAbdq2dZ2P6_b9EAk9nhE-S-ytIJ_qhA_I",
    authDomain: "tamilsangam-ccee0.firebaseapp.com",
    databaseURL: "https://tamilsangam-ccee0.firebaseio.com",
    projectId: "tamilsangam-ccee0",
    storageBucket: "tamilsangam-ccee0.appspot.com",
    messagingSenderId: "346000817286",
    appId: "1:346000817286:web:251af1723ea33d4aeee507"
   }
firebase.initializeApp(configOptions);

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')